import * as React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { usePatronContext } from "components/providers/Patron/PatronContext";
import { useGlobalConfig } from "components/providers/GlobalConfig/globalConfig";

import { useOrderContext } from "components/providers/Order/OrderContext";
import { constants, images, config, Copy } from "utils";
import { useDrawers } from "../../contexts/Drawers";
import AccountDrawer from "Header/AccountDrawer";

const {
  ORDER_TYPES: { PICKUP, DELIVERY, KIOSK },
} = constants;

const regexpsLogo = [new RegExp("^/location")];
const regexpsMarket = [new RegExp("^/market")];
const regexpsMenuDiscovery = [new RegExp("/menu-discovery")];
const regexpsMarketplaceLocation = [new RegExp("/location")];

const regexpsCart = [
  new RegExp("^/$"),
  new RegExp("^/checkout"),
  new RegExp("^/profile"),
  new RegExp("^/card"),
  new RegExp("^/sign-up"),
];
const regexpsBack = [
  new RegExp("^/$"),
  new RegExp("^/checkout"),
  new RegExp("^/profile"),
  new RegExp("^/card"),
  new RegExp("^/sign-up"),
];
const regexpsBackMenu = [new RegExp("^/profile")];
const regexpsBackCheckout = [new RegExp("^/checkout")];

const parsePath = (string) => {
  const subPath = string.split("/").filter((str) => str.length > 0)[0];
  if (string === "/") return "home";
  if (subPath === "location") return "menu";
  return string;
};

const getOrderType = (orderType) => {
  switch (orderType) {
    case PICKUP:
      return Copy.HEADER_STATIC.ORDER_FROM_PICKUP_TEXT;
    case KIOSK:
      return Copy.HEADER_STATIC.ORDER_FROM_KIOSK_TEXT;
    case DELIVERY:
      return Copy.HEADER_STATIC.ORDER_FROM_DELIVERY_TEXT;
    default:
      return "";
  }
};

const withHeader = (Component) => (props) => {
  const [isLogoutDrawerOpen, setIsLogoutDrawerOpen] = React.useState(false);
  const [isLoginDrawerOpen, setIsLoginDrawerOpen] = React.useState(false);
  const [isCartDrawerOpen, setIsCartDrawerOpen] = React.useState(false);

  const { toggleDrawer, isOpen } = useDrawers();
  const orderContext = useOrderContext();
  const patronContext = usePatronContext();
  const globalContext = useGlobalConfig();
  const location = useLocation();
  const history = useHistory();
  const { diningOption } = orderContext.order;
  const orderType = getOrderType(diningOption);
  const trackerPath = parsePath(location.pathname);

  const cartIconSrc = orderContext.items.length
    ? images?.icon_cart || config?.images?.icon_cart
    : images?.icon_empty_cart || config?.images?.icon_empty_cart;

  React.useEffect(() => {
    const { lastLocation, isAppleSignUp, isFacebookSignUp } = globalContext;
    if (!lastLocation) return;
    if (isAppleSignUp || isFacebookSignUp) {
      if (lastLocation.search("/location/") !== -1) {
        setIsCartDrawerOpen(true);
      } else if (lastLocation === "/") {
        setIsLoginDrawerOpen(true);
      }
    }
  }, []);

  const toggleLogoutDrawer = () => setIsLogoutDrawerOpen(!isLogoutDrawerOpen);
  const toggleLoginDrawer = () => setIsLoginDrawerOpen(!isLoginDrawerOpen);

  const handleAccountClick = () =>
    toggleDrawer({
      title: "Account",
      render: () => AccountDrawer({ onLogoutClick: toggleLogoutDrawer }),
      hideHeader: true,
      // TODO: Only show this on a location page
      drawerButtonProps: { label: "Back to Menu" },
    });

  const returnProps = {
    cartCount: orderContext.items.length,
    cartIconSrc,
    diningOption,
    history,
    isCartDrawerOpen,
    isLoginDrawerOpen,
    isLogoutDrawerOpen,
    location: orderContext.location,
    orderContext,
    orderType,
    patronContext,
    globalContext,
    regexpsBack,
    regexpsBackCheckout,
    regexpsBackMenu,
    regexpsMarketplaceLocation,
    regexpsCart,
    regexpsLogo,
    regexpsMarket,
    routerLocation: location,
    setIsLoginDrawerOpen,
    setIsLogoutDrawerOpen,
    toggleLoginDrawer,
    toggleLogoutDrawer,
    trackerPath,
    regexpsMenuDiscovery,
    handleAccountClick,
    isOpen,
  };

  return <Component {...props} {...returnProps} />;
};

export default withHeader;
